import { COLUMN_ORDER_DEALT_TRACKING } from "../../shared/cubiq-services";
import { LadderPair } from "../../shared/cubiq-services/model/orders/LadderPair";
import { LadderRate } from "../../shared/cubiq-services/model/orders/LadderRate";

export const INSTRUMENT_COLLATOR = new Intl.Collator("en", {
  numeric: false,
  sensitivity: "base",
});

export const SORT_LADDER_TRACKING = function sortLadderTracking(
  this: null,
  valueA: number,
  valueB: number,
  nodeA,
  nodeB,
): number {
  let valA: number = nodeA.data[COLUMN_ORDER_DEALT_TRACKING];
  let valB: number = nodeB.data[COLUMN_ORDER_DEALT_TRACKING];
  let cmp = 0;

  if (valA === valB) {
    cmp = nodeA.data.aggregateOrderId.compare(nodeB.data.aggregateOrderId);
    if (cmp === 0) {
      return nodeB.data.aggregateIndex - nodeA.data.aggregateIndex;
    }
    return cmp * Math.sign(valA);
  } else {
    cmp = Number(valA) - Number(valB);

    if (cmp === 0 && valA !== Number.MAX_VALUE && valA !== 0) {
      return nodeA.data.orderId.compare(nodeB.data.orderId) * Math.sign(valA);
    }

    return cmp;
  }
};

export const SORT_INSTRUMENT = function sortInstrument(
  this: null,
  valueA: string,
  valueB: string,
): number {
  return INSTRUMENT_COLLATOR.compare(valueA, valueB);
};

export const SORT_PERC_AWAY = function sortPercAway(
  this: null,
  valueA: number,
  valueB: number,
  nodeA,
  nodeB,
): number {
  let valA = nodeA.data.percSort;
  let valB = nodeB.data.percSort;

  if (typeof nodeA.data.percSort !== "number" || typeof nodeB.data.percSort !== "number") {
    throw new Error(`Invalid SORT_PERC_AWAY data ${nodeA.data.percSort} ${nodeB.data.percSort}`);
  }

  let cmp = valA - valB;

  if (cmp === 0) {
    if (cmp === 0 && valA !== 0) {
      return nodeA.data.orderId.compare(nodeB.data.orderId) * Math.sign(valA);
    }
  }

  return cmp;
};
